<template>
  <div>
    <Tree :data="treeData" ref="tree" @on-select-change="selectTree"></Tree>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      treeData: [],
    };
  },
  methods: {
    getUserTree() {
      axios({
        method: "post",
        url: axios.bm + "/user/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        console.log(res);
        var arr = [];
        for (let i = 0; i < data.length; i++) {
          data[i].title = data[i].account;
          if (data[i].useState == 0) {
            arr.push(data[i]);
          }
        }
        console.log(arr);
        this.treeData = arr;
      });
    },
    selectTree(x, y) {
      this.$emit("user", y, x);
    },
  },
  mounted() {
    this.getUserTree();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/userTree.vue